import { gql } from 'graphql-request'

import { AccessInstructionQueries } from './accessInstructions.queries'

export namespace PropertyQueries {
  export const QUERY_KEYS = {
    getPropertiesList: 'getPropertiesList',
    getReservationProperty: 'getReservationProperty',
  }

  export function getPropertiesList() {
    return gql`
      query getPropertiesList($filter: PropertiesFilter = { limit: 20 }, $searchString: String) {
        properties(filter: $filter, searchString: $searchString) {
          id
          name
          address1
          managementCompany {
            name
          }
        }
      }
    `
  }
  export function getReservationProperty() {
    return gql`
      query getReservationProperty($id: Int!) {
        property(id: $id) {
          slug
          id
          state
          zip
          address1
          address2
          name
          propertyScreeningRequired
          mailboxInstructions
          trashInstructions
          landingDirect
          mondayOpen
          mondayClose
          tuesdayOpen
          tuesdayClose
          wednesdayOpen
          wednesdayClose
          thursdayOpen
          thursdayClose
          fridayOpen
          fridayClose
          saturdayOpen
          saturdayClose
          sundayOpen
          sundayClose
          parkingAvailable
          paidAssigned
          firstComeFirstServed
          controlledAccess
          decalRequired
          fobRequired
          waitlist
          thirdPartyManaged
          paidAssignedCost
          parkingNotes
          smartLockInstallApproval
          landingLivingApplicationStatus
          recordBlockReasons {
            id
            blockReason {
              description
            }
          }
          accessInstructions {
            ...AccessInstructionDetails
          }
          managementCompany {
            name
          }

          contacts {
            name
            phoneNumber
            email
          }
          leasedParkingSpots {
            spotNumber
            spotDetails
            status
            home {
              unitNumber
            }
          }
        }
      }
      ${AccessInstructionQueries.ACCESS_INSTRUCTIONS_DETAILS}
    `
  }
}
